import React from 'react';
import './relationship-type-selector.css';

const RELATIONSHIP_TYPES = [
  'Family', 
  'Personal', 
  'Professional', 
  'Charitable', 
  'Education',
];

const RelationshipTypeSelector = ({ selectedType, onTypeChange }) => {
  const buttonClassName = (type) => 
    `type-button ${selectedType === type ? 'selected' : ''}`;

  return (
    <div className="relationship-type-selector">
      <label>Relationship Type</label>
      <div className="type-buttons">
        {RELATIONSHIP_TYPES.map(type => (
          <button
            key={type}
            className={buttonClassName(type)}
            onClick={() => onTypeChange(type)}
          >
            {type}
          </button>
        ))}
      </div>
    </div>
  );
};

export default RelationshipTypeSelector;
